import * as React from 'react';
import { AppLanguage, DirectionKind } from '~/common/enums/enums';
import {
  MarathonInfoPayload,
  MarathonQuestion,
  PostMultilingualLink,
} from '~/common/types/types';
import {
  TagList,
  AuthorsList,
  LanguageNavigator,
} from '~/components/common/common';
import { DirectionList, QuestionsList } from '../components';
import * as styles from './marathon.module.scss';

const MIN_MULTILINGUALISM_COUNT = 2;

type Props = {
  questions: MarathonQuestion[];
  directions: DirectionKind[];
  defaultDirection: DirectionKind | null;
  currentLanguage: AppLanguage;
  marathonYear: string;
  marathonInfoPayload: MarathonInfoPayload;
  multilingualLink: PostMultilingualLink;
};

const Marathon: React.FC<Props> = ({
  questions,
  directions,
  defaultDirection,
  currentLanguage,
  marathonYear,
  marathonInfoPayload,
  multilingualLink,
}) => {
  const { author, tags, getTitle, getDescription } = marathonInfoPayload;
  const title = getTitle(marathonYear, currentLanguage);
  const description = getDescription(
    marathonYear,
    currentLanguage,
    defaultDirection,
  );
  const languages = Object.keys(multilingualLink) as AppLanguage[];

  const hasLocalized = languages.length >= MIN_MULTILINGUALISM_COUNT;

  return (
    <>
      <TagList tags={tags} />
      <h1 className={styles.postMainTitle}>{title}</h1>
      <div className={styles.authorsWrapper}>
        <AuthorsList authors={[author]} />
      </div>
      {hasLocalized && (
        <div className={styles.languageWrapper}>
          <LanguageNavigator
            languages={languages}
            currentLanguage={currentLanguage}
            multilingualLink={multilingualLink}
          />
        </div>
      )}
      <p className={styles.description}>{description}</p>
      <div className={styles.directionsWrapper}>
        <DirectionList
          directions={directions}
          activeDirection={defaultDirection}
          year={marathonYear}
          currentLanguage={currentLanguage}
        />
      </div>
      <QuestionsList questions={questions} />
    </>
  );
};

export { Marathon };
